import React, { useState, useEffect } from 'react';
import { Plus, Search, Edit2, Trash2 } from 'lucide-react';
import axiosInstance from '@/axios';
import Modal from '@/pages/Other/Modal';

const PricingPlans = () => {
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('create');
    const [formData, setFormData] = useState({
        id: '',
        label: '',
        title: '',
        description: '',
        button_title: '',
        button_plan: '',
        sections: [{ initial: '', rest: '' }], // NEW
    });

    useEffect(() => {
        fetchPlans();
    }, []);

    const fetchPlans = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get('/pricing');
            console.log("res.data.data", res.data);
            setPlans(res.data || []);
        } catch (error) {
            console.error('Error fetching pricing plans:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const resetForm = () => {
        setFormData({
            id: '',
            label: '',
            title: '',
            description: '',
            button_title: '',
            button_plan: '',
            sections: [{ initial: '', rest: '' }]
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (modalType === 'create') {
                await axiosInstance.post('/pricing', formData);
            } else {
                await axiosInstance.put(`/pricing/${formData.id}`, formData);
            }
            fetchPlans();
            setShowModal(false);
            resetForm();
        } catch (error) {
            console.error('Failed to submit pricing:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (plan) => {
        setFormData(plan);
        setModalType('edit');
        setShowModal(true);
    };
    const handleSectionChange = (index, e) => {
        const { name, value } = e.target;
        const updatedSections = [...formData.sections];
        updatedSections[index][name] = value;
        setFormData((prev) => ({ ...prev, sections: updatedSections }));
    };

    const addSection = () => {
        setFormData((prev) => ({
            ...prev,
            sections: [...prev.sections, { initial: '', rest: '' }]
        }));
    };

    const removeSection = (index) => {
        const updatedSections = formData.sections.filter((_, i) => i !== index);
        setFormData((prev) => ({ ...prev, sections: updatedSections }));
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this plan?')) return;

        setLoading(true);
        try {
            await axiosInstance.delete(`/pricing/${id}`);
            fetchPlans();
        } catch (error) {
            console.error('Delete error:', error);
        } finally {
            setLoading(false);
        }
    };

    const filteredPlans = plans?.filter(plan =>
        plan?.label?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        plan?.title?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    console.log("filteredPlans", filteredPlans);

    return (
        <div className="container mx-auto px-5 mt-3">
            <h1 className="text-2xl font-bold mb-4 p-4 bg-[#264b82] text-white rounded-md">Pricing Plans</h1>

            <div className="flex flex-col md:flex-row gap-4 items-center justify-between mb-4">
                <div className="relative flex-1 max-w-md">
                    <Search className="!absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                    <input
                        type="text"
                        placeholder="Search Plans..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500"
                    />
                </div>
                <button
                    onClick={() => {
                        setModalType('create');
                        resetForm();
                        setShowModal(true);
                    }}
                    className="bg-[#264b82] text-white px-6 py-3 rounded-xl flex items-center gap-2"
                >
                    <Plus className="h-5 w-5" />
                    Add Plan
                </button>
            </div>

            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="px-6 py-4 bg-gray-50 border-b">
                    <h2 className="text-xl font-semibold text-gray-800">All Plans</h2>
                </div>

                {loading ? (
                    <div className="flex justify-center py-12">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="px-6 py-3 uppercase text-sm">Label</th>
                                    <th className="px-6 py-3 uppercase text-sm">Price</th>
                                    <th className="px-6 py-3 uppercase text-sm">Button Title</th>
                                    <th className="px-6 py-3 uppercase text-sm">Plan</th>
                                    <th className="px-6 py-3 uppercase text-sm">Sections</th> {/* NEW */}
                                    <th className="px-6 py-3 uppercase text-sm">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredPlans.map((plan) => {
                                    console.log("plan,", plan);
                                    return (
                                        <tr key={plan.id} className="hover:bg-gray-50 border-b">
                                            <td className="px-6 py-4">{plan.label}</td>
                                            <td className="px-6 py-4">{plan.title}</td>
                                            <td className="px-6 py-4">{plan.button_title}</td>
                                            <td className="px-6 py-4">{plan.button_plan}</td>
                                            <td className="px-6 py-4">
                                                {plan.sections && plan.sections.length > 0 ? (
                                                    <ul className="list-disc ml-4 text-sm text-gray-700 space-y-1">
                                                        {plan.sections.map((sec, i) => (
                                                            <li key={i}>
                                                                <span className="font-semibold">{sec.initial}</span> {sec.rest}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <span className="text-gray-400 italic">No sections</span>
                                                )}
                                            </td>

                                            <td className="px-6 py-4 flex space-x-2">
                                                <button
                                                    onClick={() => handleEdit(plan)}
                                                    className="text-indigo-600 hover:text-indigo-800"
                                                >
                                                    <Edit2 size={18} />
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(plan.id)}
                                                    className="text-red-600 hover:text-red-800"
                                                >
                                                    <Trash2 size={18} />
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })}
                                {filteredPlans.length === 0 && (
                                    <tr>
                                        <td colSpan={5} className="text-center py-8 text-gray-500">No plans found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Modal */}
            {showModal && (
                <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                    <div className="bg-[#264b82] px-6 py-4 text-white">
                        <h3 className="text-xl font-semibold">
                            {modalType === 'create' ? 'Add Plan' : 'Edit Plan'}
                        </h3>
                    </div>

                    <form onSubmit={handleSubmit} className="p-6 space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <input
                                type="text"
                                name="label"
                                placeholder="Label"
                                value={formData.label}
                                onChange={handleInputChange}
                                required
                                className="input-style"
                            />
                            <input
                                type="text"
                                name="title"
                                placeholder="Price"
                                value={formData.title}
                                onChange={handleInputChange}
                                required
                                className="input-style"
                            />
                        </div>
                        <textarea
                            name="description"
                            placeholder="Description"
                            value={formData.description}
                            onChange={handleInputChange}
                            className="input-style"
                            rows={3}
                        />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <input
                                type="text"
                                name="button_title"
                                placeholder="Button Title"
                                value={formData.button_title}
                                onChange={handleInputChange}
                                required
                                className="input-style"
                            />
                            <input
                                type="text"
                                name="button_plan"
                                placeholder="Button Plan"
                                value={formData.button_plan}
                                onChange={handleInputChange}
                                required
                                className="input-style"
                            />
                        </div>
                        <div className="space-y-2">
                            <h4 className="text-sm font-semibold text-gray-700">Sections</h4>
                            {formData.sections.map((section, index) => (
                                <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                    <input
                                        type="text"
                                        name="initial"
                                        placeholder="Initial"
                                        value={section.initial}
                                        onChange={(e) => handleSectionChange(index, e)}
                                        required
                                        className="input-style"
                                    />
                                    <div className="flex items-center gap-2">
                                        <input
                                            type="text"
                                            name="rest"
                                            placeholder="Rest"
                                            value={section.rest}
                                            onChange={(e) => handleSectionChange(index, e)}
                                            required
                                            className="input-style flex-1"
                                        />
                                        {formData.sections.length > 1 && (
                                            <button
                                                type="button"
                                                onClick={() => removeSection(index)}
                                                className="text-red-500 hover:text-red-700"
                                            >
                                                Remove
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                            <button
                                type="button"
                                onClick={addSection}
                                className="text-sm text-blue-600 hover:underline mt-2"
                            >
                                + Add Section
                            </button>
                        </div>

                        <div className="flex justify-end space-x-2 pt-4 border-t">
                            <button
                                type="button"
                                onClick={() => setShowModal(false)}
                                className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-6 py-2 bg-[#264b82] text-white rounded-lg disabled:opacity-50"
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : modalType === 'create' ? 'Create' : 'Update'}
                            </button>
                        </div>
                    </form>
                </Modal>
            )}
        </div>
    );
};

export default PricingPlans;
